module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="paylateBnr">\r\n	<div class="paylateBnr__container">\r\n		<div class="banner-close" data-banner="paylate_закрыть" data-index="'+
((__t=(hotelIndex))==null?'':__t)+
'">\r\n			<i class="icon icon-i16_close"></i>\r\n		</div>\r\n\r\n		' + require("../parts/title.html").apply(null,arguments) + '\r\n\r\n		<div class="paylateBnr__description">\r\n            Все варианты оплаты доступны на странице заполнения паспортных данных после выбора тура.\r\n		</div>\r\n\r\n		' + require("../parts/infoBlock.html").apply(null,arguments) + '\r\n\r\n		<div class="paylateBnr__link">\r\n			<a href="/tury-v-rassrochku" target="_blank">Как купить тур в рассрочку</a>\r\n		</div>\r\n	</div>\r\n</div>\r\n\r\n\r\n';
}
return __p;
};
